var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "d-flex justify-content-between" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-3" }, [
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c("SignaturesContainer", {
                attrs: {
                  signatures: _vm.signatures,
                  "closable-sign": false,
                  placeholder: "Buscar Firma"
                },
                model: {
                  value: _vm.signatureSelected,
                  callback: function($$v) {
                    _vm.signatureSelected = $$v
                  },
                  expression: "signatureSelected"
                }
              }),
              _c("h5", { staticClass: "text-left" }, [
                _vm._v(
                  " Por favor, haz click en la estampa que quieres posicionar "
                )
              ])
            ],
            1
          )
        ]),
        _c(
          "div",
          { staticClass: "col-9" },
          [
            _c("PdfViewport", {
              attrs: {
                "default-page": _vm.defaultPage || 1,
                "closable-sign": false,
                path: _vm.file.path,
                name: _vm.file.name,
                signatures: Object.values(_vm.signaturesDroppedData),
                "signature-width": _vm.signatureWidth,
                "signature-height": _vm.signatureHeight,
                "signature-type": _vm.signatureType
              },
              on: {
                loaded: function($event) {
                  return _vm.$emit("loaded")
                },
                "page-click": _vm.onSignatureDropped,
                "signature-delete": _vm.onSignatureDelete,
                "signature-drag-end": _vm.onSignatureDragEnd
              }
            })
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }